//@author: devin
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { Item } from "../../../pojo/Item";
import { OrganizationTooltipResponse } from "../../../services/tooltip.service";
import { S25ItemTooltip } from "./s25.item.tooltip.directive";

@TypeManagerDecorator("s25-organization-tooltip")
@Component({
    selector: "s25-organization-tooltip",
    template: `
        @if (!loaded()) {
            Loading...
        } @else if (!item()) {
            Could not load organization details
        } @else {
            <div class="boxHeader">
                <div class="boxHeaderName">{{ item().item_name }}</div>
            </div>
            <div class="boxBody">
                @for (row of item().rows; track $index) {
                    <div>
                        <span class="c-dataLabel"> {{ row.name }}</span>
                        <span> {{ row.value }}</span>
                    </div>
                }
            </div>
        }
    `,
    host: {
        "[class.organizationBox]": "loaded()",
    },
    styles: `
        .boxHeaderName {
            margin-bottom: 0.5em;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class S25OrganizationTooltip extends S25ItemTooltip<OrganizationTooltipResponse> {}
